import React from 'react'
import { ReSendEmailSVG } from '../../../assets/ReSendEmailSVG'
import { useSolicitudes } from '../../../hooks/useSolicitudes';

export const ResendSolicitudButton = ({id}) => {

   const {reenviarSolicitud} = useSolicitudes()
  

  return (
   <p style={{cursor:'pointer'}} onClick={() => reenviarSolicitud(id) } > <ReSendEmailSVG/> </p>
  )
}
